import { Typography } from '@mui/material';
import dayjs from 'dayjs';
import { useDatePickerStore } from '../../../hooks/use-store';
import { useDatePickerContext } from '../../../hooks/use-date-picker-context';
import { Button } from '@/components/ui/button';

type Props = {
  anchorElRef: React.RefObject<HTMLButtonElement>;
};

export function Trigger({ anchorElRef }: Props) {
  const { toggleOpen } = useDatePickerStore((t) => t.actions);
  const { value } = useDatePickerContext();

  return (
    <Button
      ref={anchorElRef}
      onClick={() => toggleOpen()}
      sx={{ width: '100%', justifyContent: 'space-between' }}
    >
      <Typography
        sx={{
          color: 'var(--Gray-900, #101828)',
          fontFamily: 'Inter',
          fontSize: '16px',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: '24px',
        }}
      >
        {dayjs(value).format('DD.MM.YYYY, HH:mm')}
      </Typography>

      <i className="fa-regular fa-calendar" style={{ fontSize: '20px', color: '#667085' }} />
    </Button>
  );
}
